import React from 'react';
import { Header } from 'semantic-ui-react';

const Heading = ({ block }) => (
  <Header as={block.level === 3 ? 'h4' : 'h3'} style={{ marginTop: '2em' }}>
    {block.text}
  </Header>
);

export default Heading;
